import { http_client } from "@/plugins/http_client";

const obtenerSolicitudes = async (params) =>
  await http_client(`/api/cargas-iniciales/solicitud`, params, "get");

const obtenerSolicitud = async (id_solicitud) =>
    await http_client(`/api/cargas-iniciales/solicitud/${id_solicitud}`, {}, "get");

const accionSolicitud = async (accion, id_solicitud, body) =>
  http_client(`/api/cargas-iniciales/solicitud/${id_solicitud}/${accion}`, body, "put");

const descargarArchivoSolicitud = async (body) =>
  await http_client(`/api/cargas-iniciales/archivo/descarga`, body, "post");

// Catalogos
const listarEstados = async () =>
  await http_client(`/api/cargas-iniciales/solicitud/estados`, {}, "get");

const listarCargasIniciales = async () =>
  await http_client(`api/cargas-iniciales/cargas`, {}, "get");

export default {
  obtenerSolicitudes,
  obtenerSolicitud,
  accionSolicitud,
  listarEstados,
  listarCargasIniciales,
  descargarArchivoSolicitud,
};
